<table>
  <tr *ngFor="let data of tableData">
    <td *ngFor="let dataCount of getDataRowArray(data)">
      <markdown [data]="getNextDataInfo(data)"></markdown>
    </td>
  </tr>
</table>
